import { useState } from "react";
import useDebounce from "../../hooks/useDebounce";
import "./styles.scss";
export function Filter({ value, onChange }) {
  const [displayValue, setDisplayValue] = useState(value);
  const debouncedChange = useDebounce(onChange, 500);

  function handleChange({ target }) {
    setDisplayValue(target.value);
    debouncedChange(target.value);
  }

  return (
      <div className='form-group'>
        <label>Filtre por Nome</label>
        <input
        type="search"
        value={displayValue}
        onChange={handleChange}
        placeholder="Digite no minímo 3 letras"
        className='form-control'
      />
      </div>
  );
}
